/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DBHistory,
  DBHistoryOptional,
  DBHistoryMetaI,
  DBHistoryTrackedI,
} from "./dbhistory";
import { DBHistoryTracked, DBHistoryMeta } from "./dbhistory";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderBase,
  OrderBaseOptional,
  OrderBaseMetaI,
  OrderBaseTrackedI,
} from "./order-base";
import { OrderBaseTracked, OrderBaseMeta } from "./order-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderItemReportDTO,
  OrderItemReportDTOOptional,
  OrderItemReportDTOMetaI,
  OrderItemReportDTOTrackedI,
} from "./order-item-report-dto";
import {
  OrderItemReportDTOTracked,
  OrderItemReportDTOMeta,
} from "./order-item-report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentReportDTO,
  OrderPaymentReportDTOOptional,
  OrderPaymentReportDTOMetaI,
  OrderPaymentReportDTOTrackedI,
} from "./order-payment-report-dto";
import {
  OrderPaymentReportDTOTracked,
  OrderPaymentReportDTOMeta,
} from "./order-payment-report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderRef,
  OrderRefOptional,
  OrderRefMetaI,
  OrderRefTrackedI,
} from "./order-ref";
import { OrderRefTracked, OrderRefMeta } from "./order-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderReportBase,
  OrderReportBaseOptional,
  OrderReportBaseMetaI,
  OrderReportBaseTrackedI,
} from "./order-report-base";
import {
  OrderReportBaseTracked,
  OrderReportBaseMeta,
} from "./order-report-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderSource,
  OrderSourceOptional,
  OrderSourceMetaI,
  OrderSourceTrackedI,
} from "./order-source";
import { OrderSourceTracked, OrderSourceMeta } from "./order-source";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderStateNew,
  OrderStateNewOptional,
  OrderStateNewMetaI,
  OrderStateNewTrackedI,
} from "./order-state-new";
import { OrderStateNewTracked, OrderStateNewMeta } from "./order-state-new";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";

/**
 *
 * @export
 * @interface OrderReportDTO
 */
export interface OrderReportDTOOptional extends DBHistoryOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof OrderReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof OrderReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof OrderReportDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof OrderReportDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof OrderReportDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountPaidLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountBaseLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountSubtotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountTaxesLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountTotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountDiscountLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountPaymentsPaid?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountStripePaymentsPaid?: number;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  createdBy?: string;
  /**
   *
   * @type {OrderSource}
   * @memberof OrderReportDTO
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  version?: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderReportDTO
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  squareOrderId?: string;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  assignId?: number;
  /**
   *
   * @type {Array<OrderItemReportDTO>}
   * @memberof OrderReportDTO
   */
  itemReports?: OrderItemReportDTOOptional[];
  /**
   *
   * @type {Array<OrderPaymentReportDTO>}
   * @memberof OrderReportDTO
   */
  paymentReports?: OrderPaymentReportDTOOptional[];
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  firstPaymentDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  lastPaymentDate?: Date;
}

export interface OrderReportDTO
  extends
    OrderReportDTOOptional,
    DBHistory,
    OrderBase,
    OrderRef,
    OrderReportBase,
    ReportDTO {
  /**
   *
   * @type {boolean}
   * @memberof OrderReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof OrderReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof OrderReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof OrderReportDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof OrderReportDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof OrderReportDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountPaidLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountBaseLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountSubtotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountTaxesLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountTotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountDiscountLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountPaymentsPaid?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountStripePaymentsPaid?: number;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  createdBy?: string;
  /**
   *
   * @type {OrderSource}
   * @memberof OrderReportDTO
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  version: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderReportDTO
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  squareOrderId?: string;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  assignId: number;
  /**
   *
   * @type {Array<OrderItemReportDTO>}
   * @memberof OrderReportDTO
   */
  itemReports?: OrderItemReportDTO[];
  /**
   *
   * @type {Array<OrderPaymentReportDTO>}
   * @memberof OrderReportDTO
   */
  paymentReports?: OrderPaymentReportDTO[];
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  firstPaymentDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  lastPaymentDate?: Date;
}

export interface OrderReportDTOTrackedI extends DBHistoryOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderReportDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderReportDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof OrderReportDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof OrderReportDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof OrderReportDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof OrderReportDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof OrderReportDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountPaidLineItems?: number;
  totalAmountPaidLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountBaseLineItems?: number;
  totalAmountBaseLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountSubtotalLineItems?: number;
  totalAmountSubtotalLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountTaxesLineItems?: number;
  totalAmountTaxesLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountTotalLineItems?: number;
  totalAmountTotalLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountDiscountLineItems?: number;
  totalAmountDiscountLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountPaymentsPaid?: number;
  totalAmountPaymentsPaidIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  totalAmountStripePaymentsPaid?: number;
  totalAmountStripePaymentsPaidIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {OrderSource}
   * @memberof OrderReportDTO
   */
  orderSource?: OrderSource;
  orderSourceIsSet: boolean;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountSubtotalCents?: number;
  amountSubtotalCentsIsSet: boolean;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountDiscountsCents?: number;
  amountDiscountsCentsIsSet: boolean;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountTaxesCents?: number;
  amountTaxesCentsIsSet: boolean;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderReportDTO
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  version?: number;
  versionIsSet: boolean;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderReportDTO
   */
  orderStatus?: OrderStateNew;
  orderStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  squareOrderId?: string;
  squareOrderIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {Array<OrderItemReportDTO>}
   * @memberof OrderReportDTO
   */
  itemReports?: OrderItemReportDTOTrackedI[];
  itemReportsIsSet: boolean;
  /**
   *
   * @type {Array<OrderPaymentReportDTO>}
   * @memberof OrderReportDTO
   */
  paymentReports?: OrderPaymentReportDTOTrackedI[];
  paymentReportsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  firstPaymentDate?: Date;
  firstPaymentDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderReportDTO
   */
  lastPaymentDate?: Date;
  lastPaymentDateIsSet: boolean;
}

transformDatesMap.set("OrderReportDTO", function (model: OrderReportDTO) {
  const transformDateschildReports = transformDatesMap.get("ReportDTO");
  if (transformDateschildReports) {
    model.childReports?.forEach((sub) => {
      transformDateschildReports(sub);
    });
  }
  const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
  if (transformDatesmeta) {
    model.meta?.forEach((sub) => {
      transformDatesmeta(sub);
    });
  }
  const transformDatestypeCounts = transformDatesMap.get("ReportTypeCountDTO");
  if (transformDatestypeCounts) {
    model.typeCounts?.forEach((sub) => {
      transformDatestypeCounts(sub);
    });
  }
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
  const transformDatesitemReports = transformDatesMap.get("OrderItemReportDTO");
  if (transformDatesitemReports) {
    model.itemReports?.forEach((sub) => {
      transformDatesitemReports(sub);
    });
  }
  const transformDatespaymentReports = transformDatesMap.get(
    "OrderPaymentReportDTO",
  );
  if (transformDatespaymentReports) {
    model.paymentReports?.forEach((sub) => {
      transformDatespaymentReports(sub);
    });
  }
  if (typeof model.firstPaymentDate == "string")
    model.firstPaymentDate = new Date(model.firstPaymentDate);
  if (typeof model.lastPaymentDate == "string")
    model.lastPaymentDate = new Date(model.lastPaymentDate);
});

export type OrderReportDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  totalAmountPaidLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountBaseLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountSubtotalLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountTaxesLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountTotalLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountDiscountLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountPaymentsPaid: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountStripePaymentsPaid: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  orderSource: PropertyMeta<OrderSourceMetaI>;
  //isDate: false
  //isDatetime: false
  amountSubtotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountDiscountsCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTaxesCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  version: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  orderStatus: PropertyMeta<OrderStateNewMetaI>;
  //isDate: false
  //isDatetime: false
  squareOrderId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  itemReports: PropertyMeta<OrderItemReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  paymentReports: PropertyMeta<OrderPaymentReportDTOMetaI>;
  //isDate: false
  //isDatetime: true
  firstPaymentDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  lastPaymentDate: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var OrderReportDTOMeta: OrderReportDTOMetaI = {} as OrderReportDTOMetaI;
OrderReportDTOMeta = typeMeta("OrderReportDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
  totalAmountPaidLineItems: propertyMeta(
    "totalAmountPaidLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountBaseLineItems: propertyMeta(
    "totalAmountBaseLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountSubtotalLineItems: propertyMeta(
    "totalAmountSubtotalLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountTaxesLineItems: propertyMeta(
    "totalAmountTaxesLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountTotalLineItems: propertyMeta(
    "totalAmountTotalLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountDiscountLineItems: propertyMeta(
    "totalAmountDiscountLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountPaymentsPaid: propertyMeta(
    "totalAmountPaymentsPaid",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountStripePaymentsPaid: propertyMeta(
    "totalAmountStripePaymentsPaid",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  orderSource: propertyMeta(
    "orderSource",
    false,
    false,
    false,
    OrderSourceMeta,
  ),
  amountSubtotalCents: propertyMeta(
    "amountSubtotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountDiscountsCents: propertyMeta(
    "amountDiscountsCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTaxesCents: propertyMeta(
    "amountTaxesCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  version: propertyMeta("version", false, true, false, MetaTypesBase.number),
  orderStatus: propertyMeta(
    "orderStatus",
    false,
    false,
    false,
    OrderStateNewMeta,
  ),
  squareOrderId: propertyMeta(
    "squareOrderId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  itemReports: propertyMeta(
    "itemReports",
    true,
    false,
    false,
    OrderItemReportDTOMeta,
  ),
  paymentReports: propertyMeta(
    "paymentReports",
    true,
    false,
    false,
    OrderPaymentReportDTOMeta,
  ),
  firstPaymentDate: propertyMeta(
    "firstPaymentDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  lastPaymentDate: propertyMeta(
    "lastPaymentDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = OrderReportDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = ReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = ReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = ReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = ReportDTOMeta.typeCounts;
  metaI.interfaces = metaI.interfaces.concat([OrderReportBaseMeta]);
  metaI.totalAmountPaidLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountPaidLineItems;
  metaI.totalAmountBaseLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountBaseLineItems;
  metaI.totalAmountSubtotalLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountSubtotalLineItems;
  metaI.totalAmountTaxesLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountTaxesLineItems;
  metaI.totalAmountTotalLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountTotalLineItems;
  metaI.totalAmountDiscountLineItems.inheritedFrom =
    OrderReportBaseMeta.totalAmountDiscountLineItems;
  metaI.totalAmountPaymentsPaid.inheritedFrom =
    OrderReportBaseMeta.totalAmountPaymentsPaid;
  metaI.totalAmountStripePaymentsPaid.inheritedFrom =
    OrderReportBaseMeta.totalAmountStripePaymentsPaid;
  metaI.interfaces = metaI.interfaces.concat([DBHistoryMeta]);
  metaI.updatedOn.inheritedFrom = DBHistoryMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = DBHistoryMeta.updatedBy;
  metaI.createdOn.inheritedFrom = DBHistoryMeta.createdOn;
  metaI.createdBy.inheritedFrom = DBHistoryMeta.createdBy;
  metaI.interfaces = metaI.interfaces.concat([OrderBaseMeta]);
  metaI.orderSource.inheritedFrom = OrderBaseMeta.orderSource;
  metaI.amountSubtotalCents.inheritedFrom = OrderBaseMeta.amountSubtotalCents;
  metaI.amountDiscountsCents.inheritedFrom = OrderBaseMeta.amountDiscountsCents;
  metaI.amountTaxesCents.inheritedFrom = OrderBaseMeta.amountTaxesCents;
  metaI.amountTotalCents.inheritedFrom = OrderBaseMeta.amountTotalCents;
  metaI.amountPaidCents.inheritedFrom = OrderBaseMeta.amountPaidCents;
  metaI.version.inheritedFrom = OrderBaseMeta.version;
  metaI.orderStatus.inheritedFrom = OrderBaseMeta.orderStatus;
  metaI.squareOrderId.inheritedFrom = OrderBaseMeta.squareOrderId;
  metaI.interfaces = metaI.interfaces.concat([OrderRefMeta]);
  metaI.assignId.inheritedFrom = OrderRefMeta.assignId;
});

export class OrderReportDTOTracked
  extends DBHistoryTracked
  implements OrderReportDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  totalAmountPaidLineItems__I?: number = undefined;
  totalAmountPaidLineItemsIsSet: boolean = false;
  set totalAmountPaidLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountPaidLineItems__I = v;
      this.totalAmountPaidLineItemsIsSet = true;
    } else {
      this.totalAmountPaidLineItems__I = v || undefined;
      this.totalAmountPaidLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountPaidLineItems() {
    return this.totalAmountPaidLineItems__I;
  }
  totalAmountBaseLineItems__I?: number = undefined;
  totalAmountBaseLineItemsIsSet: boolean = false;
  set totalAmountBaseLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountBaseLineItems__I = v;
      this.totalAmountBaseLineItemsIsSet = true;
    } else {
      this.totalAmountBaseLineItems__I = v || undefined;
      this.totalAmountBaseLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountBaseLineItems() {
    return this.totalAmountBaseLineItems__I;
  }
  totalAmountSubtotalLineItems__I?: number = undefined;
  totalAmountSubtotalLineItemsIsSet: boolean = false;
  set totalAmountSubtotalLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountSubtotalLineItems__I = v;
      this.totalAmountSubtotalLineItemsIsSet = true;
    } else {
      this.totalAmountSubtotalLineItems__I = v || undefined;
      this.totalAmountSubtotalLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountSubtotalLineItems() {
    return this.totalAmountSubtotalLineItems__I;
  }
  totalAmountTaxesLineItems__I?: number = undefined;
  totalAmountTaxesLineItemsIsSet: boolean = false;
  set totalAmountTaxesLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountTaxesLineItems__I = v;
      this.totalAmountTaxesLineItemsIsSet = true;
    } else {
      this.totalAmountTaxesLineItems__I = v || undefined;
      this.totalAmountTaxesLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountTaxesLineItems() {
    return this.totalAmountTaxesLineItems__I;
  }
  totalAmountTotalLineItems__I?: number = undefined;
  totalAmountTotalLineItemsIsSet: boolean = false;
  set totalAmountTotalLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountTotalLineItems__I = v;
      this.totalAmountTotalLineItemsIsSet = true;
    } else {
      this.totalAmountTotalLineItems__I = v || undefined;
      this.totalAmountTotalLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountTotalLineItems() {
    return this.totalAmountTotalLineItems__I;
  }
  totalAmountDiscountLineItems__I?: number = undefined;
  totalAmountDiscountLineItemsIsSet: boolean = false;
  set totalAmountDiscountLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountDiscountLineItems__I = v;
      this.totalAmountDiscountLineItemsIsSet = true;
    } else {
      this.totalAmountDiscountLineItems__I = v || undefined;
      this.totalAmountDiscountLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountDiscountLineItems() {
    return this.totalAmountDiscountLineItems__I;
  }
  totalAmountPaymentsPaid__I?: number = undefined;
  totalAmountPaymentsPaidIsSet: boolean = false;
  set totalAmountPaymentsPaid(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountPaymentsPaid__I = v;
      this.totalAmountPaymentsPaidIsSet = true;
    } else {
      this.totalAmountPaymentsPaid__I = v || undefined;
      this.totalAmountPaymentsPaidIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountPaymentsPaid() {
    return this.totalAmountPaymentsPaid__I;
  }
  totalAmountStripePaymentsPaid__I?: number = undefined;
  totalAmountStripePaymentsPaidIsSet: boolean = false;
  set totalAmountStripePaymentsPaid(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountStripePaymentsPaid__I = v;
      this.totalAmountStripePaymentsPaidIsSet = true;
    } else {
      this.totalAmountStripePaymentsPaid__I = v || undefined;
      this.totalAmountStripePaymentsPaidIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountStripePaymentsPaid() {
    return this.totalAmountStripePaymentsPaid__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  orderSource__I?: OrderSource = undefined;
  orderSourceIsSet: boolean = false;
  set orderSource(v: undefined | OrderSource) {
    if (v !== undefined) {
      this.orderSource__I = v;
      this.orderSourceIsSet = true;
    } else {
      this.orderSource__I = v || undefined;
      this.orderSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderSource() {
    return this.orderSource__I;
  }
  amountSubtotalCents__I?: number = undefined;
  amountSubtotalCentsIsSet: boolean = false;
  set amountSubtotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSubtotalCents__I = v;
      this.amountSubtotalCentsIsSet = true;
    } else {
      this.amountSubtotalCents__I = v || undefined;
      this.amountSubtotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSubtotalCents() {
    return this.amountSubtotalCents__I;
  }
  amountDiscountsCents__I?: number = undefined;
  amountDiscountsCentsIsSet: boolean = false;
  set amountDiscountsCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountDiscountsCents__I = v;
      this.amountDiscountsCentsIsSet = true;
    } else {
      this.amountDiscountsCents__I = v || undefined;
      this.amountDiscountsCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountDiscountsCents() {
    return this.amountDiscountsCents__I;
  }
  amountTaxesCents__I?: number = undefined;
  amountTaxesCentsIsSet: boolean = false;
  set amountTaxesCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTaxesCents__I = v;
      this.amountTaxesCentsIsSet = true;
    } else {
      this.amountTaxesCents__I = v || undefined;
      this.amountTaxesCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTaxesCents() {
    return this.amountTaxesCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  version__I?: number = undefined;
  versionIsSet: boolean = false;
  set version(v: undefined | number) {
    if (v !== undefined) {
      this.version__I = v;
      this.versionIsSet = true;
    } else {
      this.version__I = v || undefined;
      this.versionIsSet = true;
    }
    this.changeTracker = true;
  }
  get version() {
    return this.version__I;
  }
  orderStatus__I?: OrderStateNew = undefined;
  orderStatusIsSet: boolean = false;
  set orderStatus(v: undefined | OrderStateNew) {
    if (v !== undefined) {
      this.orderStatus__I = v;
      this.orderStatusIsSet = true;
    } else {
      this.orderStatus__I = v || undefined;
      this.orderStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderStatus() {
    return this.orderStatus__I;
  }
  squareOrderId__I?: string = undefined;
  squareOrderIdIsSet: boolean = false;
  set squareOrderId(v: undefined | string) {
    if (v !== undefined) {
      this.squareOrderId__I = v;
      this.squareOrderIdIsSet = true;
    } else {
      this.squareOrderId__I = v || undefined;
      this.squareOrderIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareOrderId() {
    return this.squareOrderId__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  itemReports__I?: OrderItemReportDTOTracked[] = undefined;
  itemReportsIsSet: boolean = false;
  set itemReports(v: undefined | OrderItemReportDTOTracked[]) {
    if (v !== undefined) {
      this.itemReports__I = v;
      this.itemReportsIsSet = true;
    } else {
      this.itemReports__I = v || undefined;
      this.itemReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemReports() {
    return this.itemReports__I;
  }
  paymentReports__I?: OrderPaymentReportDTOTracked[] = undefined;
  paymentReportsIsSet: boolean = false;
  set paymentReports(v: undefined | OrderPaymentReportDTOTracked[]) {
    if (v !== undefined) {
      this.paymentReports__I = v;
      this.paymentReportsIsSet = true;
    } else {
      this.paymentReports__I = v || undefined;
      this.paymentReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentReports() {
    return this.paymentReports__I;
  }
  firstPaymentDate__I?: Date = undefined;
  firstPaymentDateIsSet: boolean = false;
  set firstPaymentDate(v: undefined | Date) {
    if (v !== undefined) {
      this.firstPaymentDate__I = v;
      this.firstPaymentDateIsSet = true;
    } else {
      this.firstPaymentDate__I = v || undefined;
      this.firstPaymentDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get firstPaymentDate() {
    return this.firstPaymentDate__I;
  }
  lastPaymentDate__I?: Date = undefined;
  lastPaymentDateIsSet: boolean = false;
  set lastPaymentDate(v: undefined | Date) {
    if (v !== undefined) {
      this.lastPaymentDate__I = v;
      this.lastPaymentDateIsSet = true;
    } else {
      this.lastPaymentDate__I = v || undefined;
      this.lastPaymentDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get lastPaymentDate() {
    return this.lastPaymentDate__I;
  }
  constructor(config?: OrderReportDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());

    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.itemReports?.forEach((a) => a.setIds());

    this.paymentReports?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: OrderReportDTOOptional,
    options?: AssignOptions,
  ): OrderReportDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (
      config.totalAmountPaidLineItems &&
      this.totalAmountPaidLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountPaidLineItems = config.totalAmountPaidLineItems;
      if (optionsRequired.unassign) this.totalAmountPaidLineItemsIsSet = false;
      else this.totalAmountPaidLineItemsIsSet = true;
    }
    if (
      config.totalAmountBaseLineItems &&
      this.totalAmountBaseLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountBaseLineItems = config.totalAmountBaseLineItems;
      if (optionsRequired.unassign) this.totalAmountBaseLineItemsIsSet = false;
      else this.totalAmountBaseLineItemsIsSet = true;
    }
    if (
      config.totalAmountSubtotalLineItems &&
      this.totalAmountSubtotalLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountSubtotalLineItems = config.totalAmountSubtotalLineItems;
      if (optionsRequired.unassign)
        this.totalAmountSubtotalLineItemsIsSet = false;
      else this.totalAmountSubtotalLineItemsIsSet = true;
    }
    if (
      config.totalAmountTaxesLineItems &&
      this.totalAmountTaxesLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountTaxesLineItems = config.totalAmountTaxesLineItems;
      if (optionsRequired.unassign) this.totalAmountTaxesLineItemsIsSet = false;
      else this.totalAmountTaxesLineItemsIsSet = true;
    }
    if (
      config.totalAmountTotalLineItems &&
      this.totalAmountTotalLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountTotalLineItems = config.totalAmountTotalLineItems;
      if (optionsRequired.unassign) this.totalAmountTotalLineItemsIsSet = false;
      else this.totalAmountTotalLineItemsIsSet = true;
    }
    if (
      config.totalAmountDiscountLineItems &&
      this.totalAmountDiscountLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountDiscountLineItems = config.totalAmountDiscountLineItems;
      if (optionsRequired.unassign)
        this.totalAmountDiscountLineItemsIsSet = false;
      else this.totalAmountDiscountLineItemsIsSet = true;
    }
    if (
      config.totalAmountPaymentsPaid &&
      this.totalAmountPaymentsPaidApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountPaymentsPaid = config.totalAmountPaymentsPaid;
      if (optionsRequired.unassign) this.totalAmountPaymentsPaidIsSet = false;
      else this.totalAmountPaymentsPaidIsSet = true;
    }
    if (
      config.totalAmountStripePaymentsPaid &&
      this.totalAmountStripePaymentsPaidApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountStripePaymentsPaid = config.totalAmountStripePaymentsPaid;
      if (optionsRequired.unassign)
        this.totalAmountStripePaymentsPaidIsSet = false;
      else this.totalAmountStripePaymentsPaidIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (
      config.orderSource &&
      this.orderSourceApplyFilter(optionsRequired.filter)
    ) {
      this.orderSource = config.orderSource;
      if (optionsRequired.unassign) this.orderSourceIsSet = false;
      else this.orderSourceIsSet = true;
    }
    if (
      config.amountSubtotalCents &&
      this.amountSubtotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSubtotalCents = config.amountSubtotalCents;
      if (optionsRequired.unassign) this.amountSubtotalCentsIsSet = false;
      else this.amountSubtotalCentsIsSet = true;
    }
    if (
      config.amountDiscountsCents &&
      this.amountDiscountsCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountDiscountsCents = config.amountDiscountsCents;
      if (optionsRequired.unassign) this.amountDiscountsCentsIsSet = false;
      else this.amountDiscountsCentsIsSet = true;
    }
    if (
      config.amountTaxesCents &&
      this.amountTaxesCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTaxesCents = config.amountTaxesCents;
      if (optionsRequired.unassign) this.amountTaxesCentsIsSet = false;
      else this.amountTaxesCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (config.version && this.versionApplyFilter(optionsRequired.filter)) {
      this.version = config.version;
      if (optionsRequired.unassign) this.versionIsSet = false;
      else this.versionIsSet = true;
    }
    if (
      config.orderStatus &&
      this.orderStatusApplyFilter(optionsRequired.filter)
    ) {
      this.orderStatus = config.orderStatus;
      if (optionsRequired.unassign) this.orderStatusIsSet = false;
      else this.orderStatusIsSet = true;
    }
    if (
      config.squareOrderId &&
      this.squareOrderIdApplyFilter(optionsRequired.filter)
    ) {
      this.squareOrderId = config.squareOrderId;
      if (optionsRequired.unassign) this.squareOrderIdIsSet = false;
      else this.squareOrderIdIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.itemReports &&
      this.itemReportsApplyFilter(optionsRequired.filter)
    ) {
      this.itemReports = config.itemReports?.map(
        (a) => new OrderItemReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemReportsIsSet = false;
      else this.itemReportsIsSet = true;
    }
    if (
      config.paymentReports &&
      this.paymentReportsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentReports = config.paymentReports?.map(
        (a) => new OrderPaymentReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.paymentReportsIsSet = false;
      else this.paymentReportsIsSet = true;
    }
    if (
      config.firstPaymentDate &&
      this.firstPaymentDateApplyFilter(optionsRequired.filter)
    ) {
      this.firstPaymentDate = config.firstPaymentDate;
      if (optionsRequired.unassign) this.firstPaymentDateIsSet = false;
      else this.firstPaymentDateIsSet = true;
    }
    if (
      config.lastPaymentDate &&
      this.lastPaymentDateApplyFilter(optionsRequired.filter)
    ) {
      this.lastPaymentDate = config.lastPaymentDate;
      if (optionsRequired.unassign) this.lastPaymentDateIsSet = false;
      else this.lastPaymentDateIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderReportDTOTrackedI {
    const cloned = {} as OrderReportDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.totalAmountPaidLineItemsIsSetDeep() &&
      this.totalAmountPaidLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountPaidLineItemsIsSet = true;
      cloned.totalAmountPaidLineItems = this.totalAmountPaidLineItems;
    } else {
      //cloned.totalAmountPaidLineItemsIsSet = false
    }
    if (
      this.totalAmountBaseLineItemsIsSetDeep() &&
      this.totalAmountBaseLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountBaseLineItemsIsSet = true;
      cloned.totalAmountBaseLineItems = this.totalAmountBaseLineItems;
    } else {
      //cloned.totalAmountBaseLineItemsIsSet = false
    }
    if (
      this.totalAmountSubtotalLineItemsIsSetDeep() &&
      this.totalAmountSubtotalLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountSubtotalLineItemsIsSet = true;
      cloned.totalAmountSubtotalLineItems = this.totalAmountSubtotalLineItems;
    } else {
      //cloned.totalAmountSubtotalLineItemsIsSet = false
    }
    if (
      this.totalAmountTaxesLineItemsIsSetDeep() &&
      this.totalAmountTaxesLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountTaxesLineItemsIsSet = true;
      cloned.totalAmountTaxesLineItems = this.totalAmountTaxesLineItems;
    } else {
      //cloned.totalAmountTaxesLineItemsIsSet = false
    }
    if (
      this.totalAmountTotalLineItemsIsSetDeep() &&
      this.totalAmountTotalLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountTotalLineItemsIsSet = true;
      cloned.totalAmountTotalLineItems = this.totalAmountTotalLineItems;
    } else {
      //cloned.totalAmountTotalLineItemsIsSet = false
    }
    if (
      this.totalAmountDiscountLineItemsIsSetDeep() &&
      this.totalAmountDiscountLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountDiscountLineItemsIsSet = true;
      cloned.totalAmountDiscountLineItems = this.totalAmountDiscountLineItems;
    } else {
      //cloned.totalAmountDiscountLineItemsIsSet = false
    }
    if (
      this.totalAmountPaymentsPaidIsSetDeep() &&
      this.totalAmountPaymentsPaidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountPaymentsPaidIsSet = true;
      cloned.totalAmountPaymentsPaid = this.totalAmountPaymentsPaid;
    } else {
      //cloned.totalAmountPaymentsPaidIsSet = false
    }
    if (
      this.totalAmountStripePaymentsPaidIsSetDeep() &&
      this.totalAmountStripePaymentsPaidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountStripePaymentsPaidIsSet = true;
      cloned.totalAmountStripePaymentsPaid = this.totalAmountStripePaymentsPaid;
    } else {
      //cloned.totalAmountStripePaymentsPaidIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.orderSourceIsSetDeep() &&
      this.orderSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderSourceIsSet = true;
      cloned.orderSource = this.orderSource;
    } else {
      //cloned.orderSourceIsSet = false
    }
    if (
      this.amountSubtotalCentsIsSetDeep() &&
      this.amountSubtotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSubtotalCentsIsSet = true;
      cloned.amountSubtotalCents = this.amountSubtotalCents;
    } else {
      //cloned.amountSubtotalCentsIsSet = false
    }
    if (
      this.amountDiscountsCentsIsSetDeep() &&
      this.amountDiscountsCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountDiscountsCentsIsSet = true;
      cloned.amountDiscountsCents = this.amountDiscountsCents;
    } else {
      //cloned.amountDiscountsCentsIsSet = false
    }
    if (
      this.amountTaxesCentsIsSetDeep() &&
      this.amountTaxesCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTaxesCentsIsSet = true;
      cloned.amountTaxesCents = this.amountTaxesCents;
    } else {
      //cloned.amountTaxesCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.versionIsSetDeep() &&
      this.versionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.versionIsSet = true;
      cloned.version = this.version;
    } else {
      //cloned.versionIsSet = false
    }
    if (
      this.orderStatusIsSetDeep() &&
      this.orderStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderStatusIsSet = true;
      cloned.orderStatus = this.orderStatus;
    } else {
      //cloned.orderStatusIsSet = false
    }
    if (
      this.squareOrderIdIsSetDeep() &&
      this.squareOrderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareOrderIdIsSet = true;
      cloned.squareOrderId = this.squareOrderId;
    } else {
      //cloned.squareOrderIdIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.itemReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemReportsIsSet = true;
      cloned.itemReports = this.itemReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemReportsIsSet = false
    }
    if (
      this.paymentReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.paymentReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentReportsIsSet = true;
      cloned.paymentReports = this.paymentReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.paymentReportsIsSet = false
    }
    if (
      this.firstPaymentDateIsSetDeep() &&
      this.firstPaymentDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstPaymentDateIsSet = true;
      cloned.firstPaymentDate = this.firstPaymentDate;
    } else {
      //cloned.firstPaymentDateIsSet = false
    }
    if (
      this.lastPaymentDateIsSetDeep() &&
      this.lastPaymentDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastPaymentDateIsSet = true;
      cloned.lastPaymentDate = this.lastPaymentDate;
    } else {
      //cloned.lastPaymentDateIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderReportDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.totalAmountPaidLineItemsApplyFilter(filter))
      this.totalAmountPaidLineItemsIsSet = false;

    if (!this.totalAmountBaseLineItemsApplyFilter(filter))
      this.totalAmountBaseLineItemsIsSet = false;

    if (!this.totalAmountSubtotalLineItemsApplyFilter(filter))
      this.totalAmountSubtotalLineItemsIsSet = false;

    if (!this.totalAmountTaxesLineItemsApplyFilter(filter))
      this.totalAmountTaxesLineItemsIsSet = false;

    if (!this.totalAmountTotalLineItemsApplyFilter(filter))
      this.totalAmountTotalLineItemsIsSet = false;

    if (!this.totalAmountDiscountLineItemsApplyFilter(filter))
      this.totalAmountDiscountLineItemsIsSet = false;

    if (!this.totalAmountPaymentsPaidApplyFilter(filter))
      this.totalAmountPaymentsPaidIsSet = false;

    if (!this.totalAmountStripePaymentsPaidApplyFilter(filter))
      this.totalAmountStripePaymentsPaidIsSet = false;

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.orderSourceApplyFilter(filter)) this.orderSourceIsSet = false;

    if (!this.amountSubtotalCentsApplyFilter(filter))
      this.amountSubtotalCentsIsSet = false;

    if (!this.amountDiscountsCentsApplyFilter(filter))
      this.amountDiscountsCentsIsSet = false;

    if (!this.amountTaxesCentsApplyFilter(filter))
      this.amountTaxesCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.versionApplyFilter(filter)) this.versionIsSet = false;

    if (!this.orderStatusApplyFilter(filter)) this.orderStatusIsSet = false;

    if (!this.squareOrderIdApplyFilter(filter)) this.squareOrderIdIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.itemReportsApplyFilter(filter)) this.itemReportsIsSet = false;

    this.itemReports?.forEach((a) => a.unassignAll(filter));
    if (!this.paymentReportsApplyFilter(filter))
      this.paymentReportsIsSet = false;

    this.paymentReports?.forEach((a) => a.unassignAll(filter));
    if (!this.firstPaymentDateApplyFilter(filter))
      this.firstPaymentDateIsSet = false;

    if (!this.lastPaymentDateApplyFilter(filter))
      this.lastPaymentDateIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.isDeleted,
      OrderReportDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.isNew,
      OrderReportDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.reportId,
      OrderReportDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.reportKey,
      OrderReportDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.reportTitle,
      OrderReportDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.reportType,
      OrderReportDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.reportStatus,
      OrderReportDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.childReports,
      OrderReportDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderReportDTOMeta.meta, OrderReportDTOMeta, this.meta, this);
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.typeCounts,
      OrderReportDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  totalAmountPaidLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.totalAmountPaidLineItems,
      OrderReportDTOMeta,
      this.totalAmountPaidLineItems,
      this,
    );
  }
  totalAmountPaidLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountPaidLineItemsIsSet &&
      this.totalAmountPaidLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountBaseLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.totalAmountBaseLineItems,
      OrderReportDTOMeta,
      this.totalAmountBaseLineItems,
      this,
    );
  }
  totalAmountBaseLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountBaseLineItemsIsSet &&
      this.totalAmountBaseLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountSubtotalLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.totalAmountSubtotalLineItems,
      OrderReportDTOMeta,
      this.totalAmountSubtotalLineItems,
      this,
    );
  }
  totalAmountSubtotalLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountSubtotalLineItemsIsSet &&
      this.totalAmountSubtotalLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountTaxesLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.totalAmountTaxesLineItems,
      OrderReportDTOMeta,
      this.totalAmountTaxesLineItems,
      this,
    );
  }
  totalAmountTaxesLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountTaxesLineItemsIsSet &&
      this.totalAmountTaxesLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountTotalLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.totalAmountTotalLineItems,
      OrderReportDTOMeta,
      this.totalAmountTotalLineItems,
      this,
    );
  }
  totalAmountTotalLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountTotalLineItemsIsSet &&
      this.totalAmountTotalLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountDiscountLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.totalAmountDiscountLineItems,
      OrderReportDTOMeta,
      this.totalAmountDiscountLineItems,
      this,
    );
  }
  totalAmountDiscountLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountDiscountLineItemsIsSet &&
      this.totalAmountDiscountLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountPaymentsPaidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.totalAmountPaymentsPaid,
      OrderReportDTOMeta,
      this.totalAmountPaymentsPaid,
      this,
    );
  }
  totalAmountPaymentsPaidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountPaymentsPaidIsSet &&
      this.totalAmountPaymentsPaidApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountStripePaymentsPaidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.totalAmountStripePaymentsPaid,
      OrderReportDTOMeta,
      this.totalAmountStripePaymentsPaid,
      this,
    );
  }
  totalAmountStripePaymentsPaidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountStripePaymentsPaidIsSet &&
      this.totalAmountStripePaymentsPaidApplyFilter(filter)
    )
      return true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.updatedOn,
      OrderReportDTOMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.updatedBy,
      OrderReportDTOMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.createdOn,
      OrderReportDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.createdBy,
      OrderReportDTOMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  orderSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.orderSource,
      OrderReportDTOMeta,
      this.orderSource,
      this,
    );
  }
  orderSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderSourceIsSet && this.orderSourceApplyFilter(filter))
      return true;

    return false;
  }
  amountSubtotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.amountSubtotalCents,
      OrderReportDTOMeta,
      this.amountSubtotalCents,
      this,
    );
  }
  amountSubtotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSubtotalCentsIsSet &&
      this.amountSubtotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountDiscountsCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.amountDiscountsCents,
      OrderReportDTOMeta,
      this.amountDiscountsCents,
      this,
    );
  }
  amountDiscountsCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountDiscountsCentsIsSet &&
      this.amountDiscountsCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTaxesCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.amountTaxesCents,
      OrderReportDTOMeta,
      this.amountTaxesCents,
      this,
    );
  }
  amountTaxesCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTaxesCentsIsSet && this.amountTaxesCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.amountTotalCents,
      OrderReportDTOMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.amountPaidCents,
      OrderReportDTOMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  versionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.version,
      OrderReportDTOMeta,
      this.version,
      this,
    );
  }
  versionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.versionIsSet && this.versionApplyFilter(filter)) return true;

    return false;
  }
  orderStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.orderStatus,
      OrderReportDTOMeta,
      this.orderStatus,
      this,
    );
  }
  orderStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderStatusIsSet && this.orderStatusApplyFilter(filter))
      return true;

    return false;
  }
  squareOrderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.squareOrderId,
      OrderReportDTOMeta,
      this.squareOrderId,
      this,
    );
  }
  squareOrderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squareOrderIdIsSet && this.squareOrderIdApplyFilter(filter))
      return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.assignId,
      OrderReportDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  itemReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.itemReports,
      OrderReportDTOMeta,
      this.itemReports,
      this,
    );
  }
  itemReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemReportsIsSet && this.itemReportsApplyFilter(filter))
      return true;

    return this.itemReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  paymentReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.paymentReports,
      OrderReportDTOMeta,
      this.paymentReports,
      this,
    );
  }
  paymentReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentReportsIsSet && this.paymentReportsApplyFilter(filter))
      return true;

    return this.paymentReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  firstPaymentDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.firstPaymentDate,
      OrderReportDTOMeta,
      this.firstPaymentDate,
      this,
    );
  }
  firstPaymentDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.firstPaymentDateIsSet && this.firstPaymentDateApplyFilter(filter))
      return true;

    return false;
  }
  lastPaymentDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportDTOMeta.lastPaymentDate,
      OrderReportDTOMeta,
      this.lastPaymentDate,
      this,
    );
  }
  lastPaymentDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lastPaymentDateIsSet && this.lastPaymentDateApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.totalAmountPaidLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountBaseLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountSubtotalLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountTaxesLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountTotalLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountDiscountLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountPaymentsPaidIsSetDeep(filter)) return true;
    if (this.totalAmountStripePaymentsPaidIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.orderSourceIsSetDeep(filter)) return true;
    if (this.amountSubtotalCentsIsSetDeep(filter)) return true;
    if (this.amountDiscountsCentsIsSetDeep(filter)) return true;
    if (this.amountTaxesCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.versionIsSetDeep(filter)) return true;
    if (this.orderStatusIsSetDeep(filter)) return true;
    if (this.squareOrderIdIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.itemReportsIsSetDeep(filter)) return true;
    if (this.paymentReportsIsSetDeep(filter)) return true;
    if (this.firstPaymentDateIsSetDeep(filter)) return true;
    if (this.lastPaymentDateIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
